import { render, staticRenderFns } from "./CollectTotalSchedule.vue?vue&type=template&id=351f51cc&scoped=true&"
import script from "./CollectTotalSchedule.vue?vue&type=script&lang=ts&"
export * from "./CollectTotalSchedule.vue?vue&type=script&lang=ts&"
import style0 from "./CollectTotalSchedule.vue?vue&type=style&index=0&id=351f51cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351f51cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VProgressCircular,VTooltip})
